import type {ReactAction} from '@netx/core/bootstrap';
import {faFolderPlus} from '@netx/core-icons';
import {type ICategory} from '@netx/core-category-next/schema';
import {canAddCategory} from '../enablers';
import {CategoryActionLabel} from '../locales';
import {CATEGORY_EVENT} from './constants';

export const categoryActionAddIcon = faFolderPlus;

/**
 * Add category
 * @param params
 * @returns Action
 */
export const categoryActionAdd = (
	category?: ICategory,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'category-add',
	cb: () => dispatcher.trigger(CATEGORY_EVENT.ADD, category),
	enableTest: () => canAddCategory(category),
	icon: categoryActionAddIcon,
	get label() {
		return category
			? CategoryActionLabel.ADD_SUBFOLDER
			: CategoryActionLabel.ADD;
	},
	...params,
});

export default categoryActionAdd;
